// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table.CustomInvoiceTable {
  width: calc(100% + 3rem);
}
.Table.CustomInvoiceTable table {
  --sp-table-header-bg: var(--bs-secondary-subtle);
  background-color: #fff;
}
.Table.CustomInvoiceTable table .TableRow {
  --cell-count: 5;
  --location-width: 15%;
  --cell-width: calc(100% / var(--cell-count));
}
.Table.CustomInvoiceTable table .TableRow.SUBTOTAL .TableCell-Content {
  text-align: right;
}
.Table.CustomInvoiceTable table .TableRow.SUBTOTAL,
.Table.CustomInvoiceTable table .TableRow.SUBTOTAL .TableCell {
  background-color: rgba(0, 0, 0, 0.045);
}
.Table.CustomInvoiceTable table .TableRow.SUBTOTAL .TableCell-Content,
.Table.CustomInvoiceTable table .TableRow.SUBTOTAL .TableCell .TableCell-Content {
  font-weight: 800;
}
.Table.CustomInvoiceTable table .TableRow.SUBTOTAL.DELETE .TableCell-Content, .Table.CustomInvoiceTable table .TableRow.SUBTOTAL.ITEM_TYPE .TableCell-Content, .Table.CustomInvoiceTable table .TableRow.SUBTOTAL.INDEX .TableCell-Content,
.Table.CustomInvoiceTable table .TableRow.SUBTOTAL .TableCell.DELETE .TableCell-Content,
.Table.CustomInvoiceTable table .TableRow.SUBTOTAL .TableCell.ITEM_TYPE .TableCell-Content,
.Table.CustomInvoiceTable table .TableRow.SUBTOTAL .TableCell.INDEX .TableCell-Content {
  visibility: hidden;
}
.Table.CustomInvoiceTable table .TableRow.SUBTOTAL.NOTES .TableCell-Content,
.Table.CustomInvoiceTable table .TableRow.SUBTOTAL .TableCell.NOTES .TableCell-Content {
  font-weight: 800;
  text-align: right;
  text-transform: uppercase;
}
.Table.CustomInvoiceTable table .TableRow .TableCell {
  --cell-span: attr(colspan type(<number>), 1);
  width: calc(var(--cell-width) * var(--cell-span));
}
.Table.CustomInvoiceTable table .TableRow .TableCell .TableCell-Content {
  align-content: center;
  text-align: center;
  padding-top: 0;
  padding-bottom: 0;
}
.Table.CustomInvoiceTable table .TableRow .TableCell .TableCell-Content input {
  padding-left: 0;
  padding-right: 0;
  border: none;
  outline: none;
  box-shadow: none;
}
.Table.CustomInvoiceTable table .TableRow .TableCell.DELETE {
  width: 2%;
}
.Table.CustomInvoiceTable table .TableRow .TableCell.INDEX {
  width: 3%;
}
.Table.CustomInvoiceTable table .TableRow .TableCell.INDEX .TableCell-Content {
  text-align: right;
}
.Table.CustomInvoiceTable table .TableRow .TableCell.ITEM_TYPE {
  width: 15%;
}
.Table.CustomInvoiceTable table .TableRow .TableCell.ITEM_TYPE .TableCell-Content {
  text-align: left;
}
.Table.CustomInvoiceTable table .TableRow .TableCell.NOTES {
  width: 70%;
}
.Table.CustomInvoiceTable table .TableRow .TableCell.NOTES .TableCell-Content {
  text-align: left;
}
.Table.CustomInvoiceTable table .TableRow .TableCell.COST {
  width: 10%;
}
.Table.CustomInvoiceTable table .TableRow .TableCell.COST .TableCell-Content {
  text-align: right;
}
.Table.CustomInvoiceTable table .TableRow .TableCell.COST .TableCell-Content .CurrencyInput:before {
  content: "";
}
.Table.CustomInvoiceTable table .TableRow .TableCell.COST .TableCell-Content .CurrencyInput input {
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/pages/InvoicePreview/components/CustomInvoiceTable/styles.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;AAAE;EACE,gDAAA;EACA,sBAAA;AAEJ;AADI;EACE,eAAA;EACA,qBAAA;EACA,4CAAA;AAGN;AADQ;EACE,iBAAA;AAGV;AADQ;;EAEE,sCAAA;AAGV;AAFU;;EACE,gBAAA;AAKZ;AAAY;;;;EACE,kBAAA;AAKd;AADY;;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;AAId;AACM;EACE,4CAAA;EACA,iDAAA;AACR;AACQ;EACE,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AACV;AAAU;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAEZ;AACQ;EACE,SAAA;AACV;AACQ;EACE,SAAA;AACV;AAAU;EACE,iBAAA;AAEZ;AACQ;EACE,UAAA;AACV;AAAU;EACE,gBAAA;AAEZ;AACQ;EACE,UAAA;AACV;AAAU;EACE,gBAAA;AAEZ;AACQ;EACE,UAAA;AACV;AAAU;EACE,iBAAA;AAEZ;AAAc;EACE,WAAA;AAEhB;AAAc;EACE,iBAAA;AAEhB","sourcesContent":[".Table.CustomInvoiceTable {\n  width: calc(100% + 3rem);\n  table {\n    --sp-table-header-bg: var(--bs-secondary-subtle);\n    background-color: #fff;\n    .TableRow {\n      --cell-count: 5;\n      --location-width: 15%;\n      --cell-width: calc(100% / var(--cell-count));\n      &.SUBTOTAL {\n        .TableCell-Content {\n          text-align: right;\n        }\n        &,\n        .TableCell {\n          background-color: rgba(0, 0, 0, 0.045);\n          .TableCell-Content {\n            font-weight: 800;\n          }\n          &.DELETE,\n          &.ITEM_TYPE,\n          &.INDEX {\n            .TableCell-Content {\n              visibility: hidden;\n            }\n          }\n          &.NOTES {\n            .TableCell-Content {\n              font-weight: 800;\n              text-align: right;\n              text-transform: uppercase;\n            }\n          }\n        }\n      }\n      .TableCell {\n        --cell-span: attr(colspan type(<number>), 1);\n        width: calc(var(--cell-width) * var(--cell-span));\n\n        .TableCell-Content {\n          align-content: center;\n          text-align: center;\n          padding-top: 0;\n          padding-bottom: 0;\n          input {\n            padding-left: 0;\n            padding-right: 0;\n            border: none;\n            outline: none;\n            box-shadow: none;\n          }\n        }\n        &.DELETE {\n          width: 2%;\n        }\n        &.INDEX {\n          width: 3%;\n          .TableCell-Content {\n            text-align: right;\n          }\n        }\n        &.ITEM_TYPE {\n          width: 15%;\n          .TableCell-Content {\n            text-align: left;\n          }\n        }\n        &.NOTES {\n          width: 70%;\n          .TableCell-Content {\n            text-align: left;\n          }\n        }\n        &.COST {\n          width: 10%;\n          .TableCell-Content {\n            text-align: right;\n            .CurrencyInput {\n              &:before {\n                content: '';\n              }\n              input {\n                text-align: right;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
